const auth = {
  id: 'auth',
  name: 'Auth',
  Input: null,
  setInitialContent: () => {
    return {};
  },
  formatContent: () => {
    return {};
  },
  valid: () => true,
  snippet: `{
    "type": "auth",
    "content": {}
}`
};

export default auth;
